import { IHttpRequestConfig, put } from "@/browser";
import { extractDataFromResponse } from "@/core/api";
import { compose } from "@/core/url";
import { IInvitation } from "@/data/invitations";

const API = {
  list: "/api/companies/{companyId}/invitations/accept",
  linkProfile: "/api/companies/invitations/link-profile",
};

export interface IFetchJobRequestApplicationListParams {
  companyId: number;
}

export const acceptAllCompanyInvitations = (
  params: IFetchJobRequestApplicationListParams,
  options?: IHttpRequestConfig,
) => {
  const url = compose(API.list, params);
  return put<IInvitation>(url, options).then(extractDataFromResponse);
};

export interface ILinkProfileData {
  token: string;
}

export const linkProfile = (data: ILinkProfileData, options?: IHttpRequestConfig) => {
  const url = compose(API.linkProfile);
  return put<undefined>(url, data, options).then(extractDataFromResponse);
};
